export const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative">
        <span className="text-2xl font-bold text-slate-900 tracking-tight">
          Page
          <span className="relative text-blue-600">
            E
            {/* Upward arrow integrated in E */}
            <svg 
              className="absolute -top-1 -right-1 w-3 h-3 text-blue-600" 
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path fillRule="evenodd" d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
            levate
          </span>
        </span>
      </div>
    </div>
  );
};
